import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "44.428",
  viewBox: "0 0 44.428 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M33.384 11.498V-.052h-22.29v11.55H0v25.228h5.167v13.222h22.898L39.26 39.715v-2.99h5.168V11.5H33.384zM13.678 2.532H30.85v8.966H13.68V2.532zM28.876 45.44v-4.863l4.863-.05-4.866 4.913zm7.8-7.548l-10.384.05v9.372H7.752v-21.43h28.874v12.008zm5.22-3.75H39.31V25.28h-.05v-2.03H5.168v10.894H2.584v-20.06h39.31v20.06z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.513 38.145h9.574v2.634h-9.574zm0-10.285h19.91v2.635h-19.91zm0 4.966h19.91v2.634h-19.91z"
  })]
});